import React from 'react';

const ModuleNotFound = (props) => (
  <div>
    Module {props.module} is not defined. Add it to load-module.js
  </div>
);

export default ModuleNotFound;